import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.BankAccountsPage.MatchBankAccountWithXeroPopup.ReconnectOrgPopup', {
    xeroDoesntGrant: 'Reconnect Xero account',
    toProceed:
        'Your current permissions do not allow adding bank accounts. Reconnect your Xero account to get the required access.',
    learnMore: 'Learn more',
    doItLater: 'Do it later',
    reconnectOrg: 'Reconnect Xero',
});
